export default __webpack_public_path__ + "static/media/ico-security.cc826062.png";